import {
  Card,
  Reduction,
  Text
} from '@/vdp/AboutThePrice/AboutThePrice.styles';
import Tag from '@/vdp/Tags/Tag';
import SubSections from '~/constants/subSections';
import { usePriceDrop } from '~/hooks/vdp';
import NewPriceIcon from '~/icons/NewPriceIcon';
import getLongMonthDayYear from '~/utilities/date/getLongMonthDayYear';
import formatAndDropDecimal from '~/utilities/formatAndDropDecimal';

export default function NewPriceCard() {
  const { price, priceDrop, previousPrice, priceUpdateDate, restrictedState } =
    usePriceDrop();
  const dateText = priceUpdateDate
    ? ` on ${getLongMonthDayYear(priceUpdateDate)}`
    : '';

  return (
    <Card id={SubSections.NewPrice}>
      <Tag
        text={restrictedState ? 'New Price' : 'Price Drop'}
        data-qa="about-the-price-badge"
        bigTag
        bgColor="bg-green-2"
      />
      <div className="flex flex-col gap-4">
        {!restrictedState && (
          <Text data-qa="about-the-price-old-price">
            was{' '}
            <span className="line-through">
              ${formatAndDropDecimal(previousPrice)}
            </span>
          </Text>
        )}
        <div className="flex items-center gap-8">
          <NewPriceIcon
            className="h-[20px] w-[20px]"
            isInRestrictedState={restrictedState}
          />
          <div className="text-blue-6 tl-header-m">
            ${formatAndDropDecimal(price)}
          </div>
          {restrictedState ? (
            <span className="w-[124px]" />
          ) : (
            <Reduction data-qa="about-the-price-reduction">
              <span className="text-green-2 tl-header-xs">
                ${formatAndDropDecimal(priceDrop)}
              </span>{' '}
              reduction
            </Reduction>
          )}
        </div>
      </div>
      <Text data-qa="about-the-price-copy">
        {restrictedState
          ? 'We are always repricing our inventory to make room for new vehicles. Don’t miss out!'
          : `We lowered our price by $${formatAndDropDecimal(
              priceDrop
            )} ${dateText} to give you more savings.`}
      </Text>
    </Card>
  );
}
